import { ResourceConfig } from '../../core/audit/model/resource-config.model';
import { Despesa } from '../despesa/despesa.model';

const despesaAudit: ResourceConfig = {
  api: 'despesas',
  path: 'despesas',
  entity: Despesa.name,
  label: 'Despesas',
  showInPage: false,
  labelTemplate: `<u>Despesa '{fornecedor.nome}'</u>`,
  columns: [
    { field: 'suprimento.controleSequencial', header: 'field.controleSuprimento', isDefaultVisible: true },
    { field: 'suprimento.ano', header: 'field.anoSuprimento', isDefaultVisible: true },
    { field: 'fornecedor.nome', header: 'field.fornecedor', isDefaultVisible: true },
    { field: 'numeroNf', header: 'field.numeroNf', isDefaultVisible: true },
    { field: 'dataNf', header: 'field.dataNf', isDefaultVisible: true, isDate: true, mask: 'dd/MM/yyyy', formatOption: 'DATE' },
    {
      field: 'listaItemDespesa',
      header: 'field.listaObjetosDaDespesa',
      isDefaultVisible: true,
      isTable: true,
      isNotExport: true,
      tableColumns: [
        { field: 'objetoDespesa.descricao', header: 'despesa.field.objeto', isDefaultVisible: true },
        { field: 'contaCorrente.descricao', header: 'despesa.field.contacorrente', isDefaultVisible: true },
        { field: 'descricao', header: 'despesa.field.descricao', isDefaultVisible: true },
        { field: 'valorTotal', header: 'despesa.field.valortotal', isDefaultVisible: true, isMoney: true }
      ]
    },
    { field: 'ativo', header: 'field.ativo', isDefaultVisible: true, isStatus: true, formatOption: 'BOOLEAN' }
  ]
};

export default despesaAudit;
